
import Hangman from './Hangman';
import './App.css';

function App() {
  return (
    <div className="App">
      <Hangman word="example" />
    </div>
  );
}

export default App;
